import styled from "styled-components";

export const BtnComfirmSlipTranfersWidgetStyled = styled.div`
  cursor: pointer;
  &.with_label {
    border: 1px solid ${({ theme }) => theme.COLORS.GRAY_1};
    border-radius: 8px;
    padding: 7px 16px;
    display: inline-flex;
    align-items: center;
    column-gap: 6px;
    background: ${({ theme }) => theme.COLORS.WHITE_1};
    transition: 0.2s;
    .btn_label {
      color: ${({ theme }) => theme.COLORS.BLACK_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S14};
      font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_SEMIBOLD};
    }
    &:hover {
      border-color: #f89900;
    }
  }
`;

export const PreRegisContainer = styled.div`
  border-radius: 0.5rem;
  padding: 1rem;
  max-width: 80vw;
  width: 100%;
  background: ${({ theme }) => theme.COLORS.WHITE_1};
  .pre_regis_layout {
    margin-bottom: 2rem;
    display: flex;
    flex-wrap: wrap;
    column-gap: 1rem;
    &.mb_1 {
      margin-bottom: 1rem;
    }
    .pr_col {
      flex-basis: calc(50% - 1rem);
      .group_block {
        .gb_title {
          margin-bottom: 0.75rem;
          color: ${({ theme }) => theme.COLORS.BLACK_2};
          font-size: ${({ theme }) => theme.FONT.SIZE.S16};
          font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_MEDIUM};
        }
        .gb_content_list {
          .gb_item {
            margin-bottom: 0.5rem;
            &:last-child {
              margin-bottom: 0;
            }
          }
        }
      }
    }
  }
  .pre_regis_action_layout {
    display: flex;
    justify-content: flex-end;
    column-gap: 1rem;
    .btn_wrap {
      width: 200px;
    }
  }
`;
